// extracted by mini-css-extract-plugin
export var base = "_4y-0";
export var updateBanner = "_4y-1";